'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_control_edit', {
    url: 'demand_control_edit/:id',
    template: '<demand-control-edit></demand-control-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand_control/edit/demand_control_edit.routes.js